import { useState, useEffect } from "react";
import {
  Container,
  Tabs,
  Tab,
  Box,
  Typography,
  Button,
  CircularProgress,
  Stack,
  Paper,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
    TituloPrincipal,
  ButtonStyle,
  buttonGuardar,
  TituloColor
} from "../Layouts/CustomStyles";
import { ServicioClinicosArea } from "../Components/EquipoClinico/servicio";
import { FuncionProfesional } from "../Components/EquipoClinico/profesional";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export const PaginaEquipoClinico = () => {
  const [tabValue, setTabValue] = useState(0);
  const [loading, setLoading] = useState(true);
    const [abrirDialogServicio, setAbrirDialogServicio] = useState(false);
     const [abrirDialogprofesional, setAbrirDialogProfesional] = useState(false);
const handleChange = (event, newValue) => {
  setTabValue(newValue);
};

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>

      <Typography sx={TituloPrincipal} gutterBottom>
        Gestión del Equipo Clínico
      </Typography>

      <Box sx={{ borderBottom: 1, mt: 4, borderColor: "divider", mb: 2 }}>
        <Tabs 
        value={tabValue}
         onChange={handleChange}
          textColor="primary"
    indicatorColor="primary"
    variant="scrollable"   // 👈 evita que se estiren a todo el ancho
    scrollButtons={false} 
           TabIndicatorProps={{
      style: {
        backgroundColor: "#6fd385ff", // 👈 mismo verde del tab activo
        height: "3px",             // 👈 grosor de la línea
        borderRadius: "2px",       // 👈 opcional, línea más suave
      },
    }}
     sx={{
      "& .MuiTab-root": {
        minWidth: "auto",
        px: 2,
        textTransform: "none",
        fontFamily: "Poppins",
        fontWeight: 500,
        borderRadius: "8px 8px 0 0", // 👈 esquinas redondeadas arriba (opcional)
      },
      "& .Mui-selected": {
        backgroundColor: "#2a8d74", // 👈 verde oscuro
        color: "#fff !important",   // 👈 letras blancas
      },
    }}>
          <Tab label="Profesionales" />
          <Tab label="Servicios Clínicos" />
        </Tabs>
      </Box>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {/* TAB 1: PROFESIONALES */}
          <TabPanel value={tabValue} index={0}>
            <Stack direction="row" justifyContent="space-between" mb={2}>
              <Typography sx={TituloColor}>Listado de Profesionales</Typography>
              <Button
                sx={buttonGuardar}
                startIcon={<AddIcon />}
                onClick={() => setAbrirDialogProfesional(true)}
              >
                Agregar Profesional
              </Button>
            </Stack>

            <Paper sx={{ p: 2 }}>
              {/* Aquí va tu lista de profesionales */}
             <FuncionProfesional
             abrirdialog={abrirDialogprofesional}
             closedialog={() => setAbrirDialogProfesional(false)}
             />
            </Paper>
          </TabPanel>

          {/* TAB 2: SERVICIOS CLÍNICOS */}
           <TabPanel value={tabValue} index={1}>
            <Stack direction="row" justifyContent="space-between" mb={2}>
              <Typography sx={TituloColor}>Servicios Clínicos</Typography>
              <Button
                sx={ButtonStyle}
                startIcon={<AddIcon />}
                onClick={() => setAbrirDialogServicio(true)}
              >
                Agregar Servicio
              </Button>
            </Stack>

            <Paper sx={{ p: 2 }}>
              <ServicioClinicosArea
                openDialog={abrirDialogServicio}
                onCloseDialog={() => setAbrirDialogServicio(false)}
              />
            </Paper>
          </TabPanel>
        </>
      )}
    </Container>
  );
};
